import * as Card from "@radix-ui/react-hover-card";
import styled, { css } from "styled-components";
import { getThemeSpace } from "../../helpers";
import { getAnimationStyle } from "./helpers";
export const Trigger = styled(Card.Trigger) `
	width: 100%;
`;
export const Content = styled(Card.Content) `
	padding: ${getThemeSpace("8")};
	border-radius: 4px;

	background-color: var(--surface-white);

	box-shadow: 0px 0px 8px #00000033;

	${({ maxWidth }) => maxWidth &&
    css `
			max-width: ${maxWidth}px;
		`}

	${({ animation }) => animation && getAnimationStyle(animation)}
`;
export const Arrow = styled(Card.Arrow) `
	fill: var(--text-invert);
`;
//# sourceMappingURL=styles.js.map